import React from 'react';

import { Link as RouterLink } from 'react-router-dom';
import { Link, Typography } from '@material-ui/core';
// see https://material-ui.com/components/material-icons/
import { Error as ErrorIcon } from '@material-ui/icons';

const Http404 = () => {
  return (
    <div>
      <ErrorIcon color="action" style={{ fontSize: 140 }} />
      <Typography variant="h4" component="h1" color="textSecondary">
        404 - Not Found
      </Typography>
      <Typography variant="body1" component="h1" color="textSecondary">
        Resource Not Found
      </Typography>

      <Link component={RouterLink} to="/" variant="body2">
        {'Return home'}
      </Link>
    </div>
  );
};

export { Http404 };
